var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "date-fns", "./RedirectionAnchor.css", "../../css", "@date-fns/upgrade/v2"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("date-fns"), require("./RedirectionAnchor.css"), require("../../css"), require("@date-fns/upgrade/v2"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.dateFns, global.RedirectionAnchor, global.css, global.v2);
    global.RedirectionAnchor = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _dateFns, _RedirectionAnchor, _css, _v) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var RedirectionAnchor = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(RedirectionAnchor, _PureComponent);

    var _super = _createSuper(RedirectionAnchor);

    function RedirectionAnchor(props) {
      var _this;

      (0, _classCallCheck2.default)(this, RedirectionAnchor);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFocusHandler", function () {
        _this.setState({
          focusAnchor: true
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBlurHandler", function () {
        _this.setState({
          focusAnchor: false
        });
      });
      _this.state = {
        focusAnchor: false
      };
      return _this;
    }

    (0, _createClass2.default)(RedirectionAnchor, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            date = _this$props.date,
            dateLocale = _this$props.dateLocale,
            focus = _this$props.focus,
            focusProgram = _this$props.focusProgram,
            focusSelectedDate = _this$props.focusSelectedDate,
            programLabel = _this$props.programLabel,
            changeDateLabel = _this$props.changeDateLabel;

        var focusStyle = _css.focuses[focus] && _css.focuses[focus]();

        return /*#__PURE__*/_react.default.createElement(_RedirectionAnchor.StyledWrapper, {
          isFocused: this.state.focusAnchor
        }, /*#__PURE__*/_react.default.createElement(_RedirectionAnchor.StyledButton, {
          focusStyle: focusStyle,
          onBlur: this.onBlurHandler,
          onClick: focusProgram,
          onFocus: this.onFocusHandler
        }, programLabel, " ", (0, _dateFns.format)((0, _v.legacyParse)(date), 'EEEE', {
          locale: dateLocale
        }), ' ', (0, _dateFns.format)((0, _v.legacyParse)(date), 'dd MMMM', {
          locale: dateLocale
        })), /*#__PURE__*/_react.default.createElement(_RedirectionAnchor.StyledButton, {
          focusStyle: focusStyle,
          onBlur: this.onBlurHandler,
          onClick: focusSelectedDate,
          onFocus: this.onFocusHandler
        }, changeDateLabel));
      }
    }]);
    return RedirectionAnchor;
  }(_react.PureComponent);

  RedirectionAnchor.propTypes = {
    date: _propTypes.default.instanceOf(Date),
    dateLocale: _propTypes.default.shape(),
    focus: _propTypes.default.string,
    focusProgram: _propTypes.default.func,
    focusSelectedDate: _propTypes.default.func,
    programLabel: _propTypes.default.string.isRequired,
    changeDateLabel: _propTypes.default.string.isRequired
  };
  RedirectionAnchor.defaultProps = {
    focus: 'rgaa',
    programLabel: 'Passer aux programmes du',
    changeDateLabel: 'Choisir une autre date'
  };
  var _default = RedirectionAnchor;
  _exports.default = _default;
});